import './AsSoon.css'
import TriangularBottom from "../../../assets/triangular/transition-triangular-bottom.svg";
import TechEu from "../../../assets/logos/techeu-color.svg";
import EuLogo from "../../../assets/logos/eu-logo.svg";
import GriftLogo from "../../../assets/logos/GritDaily_Logo.svg";

export default function AsSoon() {

    return (
        <div>
            <section className="as-soon">
                <div className="as-soon-container">
                    <div className="as-soon-content">
                        <h1 style={{
                            color: '#CBD5E1',
                            fontSize: '20px',
                            fontWeight: '400',
                            wordWrap: 'break-word',
                            paddingLeft: '24px',
                            marginBottom: '20px',
                            textAlign: 'start'
                        }}>
                            As seen on:
                        </h1>
                        <div className={"as-soon-logos"}>
                            <a href="https://www.eu-startups.com/2024/01/denmarks-rising-stars-10-innovative-startups-you-must-keep-an-eye-on-in-2024-and-beyond/"
                               target="_blank">
                                <img
                                    src={EuLogo}
                                    alt="EU logo"
                                />
                            </a>
                            <a href="https://tech.eu/2023/12/22/ai-powered-feedback-management-platform-magic-feedback-raises/"
                               target="_blank">
                                <img
                                    src={TechEu}
                                    alt="Tech EU logo"
                                />
                            </a>
                            <a href="https://gritdaily.com/magic-feedback-unveils-a-new-path-in-user-feedback-management/"
                               target="_blank">
                                <img
                                    src={GriftLogo}
                                    alt="Grit Daily logo"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                <img
                    src={TriangularBottom}
                    alt="background grey triangular"
                    width="100%"
                    style={{alignSelf: 'stretch'}}
                />
            </section>
        </div>
    );
}
